import { useParams } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { Link } from 'react-router-dom'

export default function OneOnOneEditPlaceholder() {
  const { id } = useParams<{ id: string }>()

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-3xl mx-auto space-y-6">
        <header>
          <h1 className="text-3xl font-bold text-foreground mb-2">Edit 1-on-1 session</h1>
          <p className="text-muted-foreground">
            Session ID: <span className="font-mono">{id}</span>
          </p>
        </header>

        <Card className="border-dashed">
          <CardHeader>
            <CardTitle>Migration in progress</CardTitle>
            <CardDescription>
              Bring over the full edit form (participants, agenda, reminders) from the Next.js version to enable updates here.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Input disabled placeholder="Session title" />
            <Textarea disabled rows={4} placeholder="Default agenda" />
            <div className="flex gap-3">
              <Button disabled>Save changes</Button>
              <Button asChild variant="outline">
                <Link to={`/dashboard/one-on-ones/${id}`}>Cancel</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
